const ChevronLeft = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.854 6.646a.5.5 0 0 1 0 .708L10.207 12l4.647 4.646a.5.5 0 0 1-.708.708l-5-5a.5.5 0 0 1 0-.708l5-5a.5.5 0 0 1 .708 0"
      clipRule="evenodd"
    />
  </>
)
export default ChevronLeft
